export const FilterTypeEnum = {
    dropdown: 0,
    calendar: 1,
};
